__turbopack_context__.v({
  "banner": "PageFlag-module-scss-module__h5zI6W__banner",
  "description": "PageFlag-module-scss-module__h5zI6W__description",
  "single-line": "PageFlag-module-scss-module__h5zI6W__single-line",
  "small": "PageFlag-module-scss-module__h5zI6W__small",
});
